
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Divider from 'vux/src/components/divider/index.vue'

import VehicleRequire from './VehicleRequire'
import VehicleResource from './VehicleResource'
import AddSubmit from './AddSubmit'
import AddForm from './AddForm'
import AddFormOther from './AddFormOther'
import AddFormView from './AddFormView'
import axios from 'axios'
import wx from 'weixin-js-sdk';
import { Debounce } from '../utils'
import Bus from '../bus'
Date.prototype.Format = function (fmt) { //author: meizz
var o = {
"M+": this.getMonth() + 1,                 //月份
"d+": this.getDate(),                    //日
"h+": this.getHours(),                   //小时
"m+": this.getMinutes(),                 //分
"s+": this.getSeconds(),                 //秒
"q+": Math.floor((this.getMonth() + 3) / 3), //季度
"S": this.getMilliseconds()             //毫秒
};
if (/(y+)/.test(fmt))
fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
for (var k in o)
if (new RegExp("(" + k + ")").test(fmt))
fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
return fmt;
}
export default {
directives: {
TransferDom
},
components: {
Group,
Cell,
Tab,
TabItem,
XInput,
XTextarea,
XButton,
Card,
Alert,
Loading,
Toast,
Icon,
Radio,
Checklist,
Datetime,
XDialog,
Flexbox,
FlexboxItem,
Divider,
VehicleRequire,
VehicleResource,
AddSubmit,
AddForm,
AddFormOther,
AddFormView
},
data () {
return {




showmodal: false,
showmodalform: false,
showmodalform2: false,
showmodalform3: false,
showmodalform4: false,
showmodalform5: false,
showmodalform6: false,
showmodalformview: false,
showmodalformview2: false,
showmodalformview3: false,
showmodalformview4: false,
showmodalformview5: false,
showmodalformview6: false,
showmodalformview7: false,
showmodalformview8: false,
showmodalformother: false,
showmodalformother2: false,
showmodalformother3: false,
showmodalformother4: false,
bannerurl: require('../assets/banner.jpg'),
banner2url: require('../assets/banner2.jpg'),
msg: 'Hello World!',
visindex: 1,
hasAuth: 0,
transform: { transform: 'translateY(0)' },
positionimg: require('../assets/1.png'),
positionimg2: require('../assets/2.png'),
positionimg3: require('../assets/3.png'),
imgList: [
{ url: 'http://ncc-yc-cpumall-ec.obs.cn-north-4.myhuaweicloud.com/h050u1t9/cfab254d-2129-4fc8-ab3b-c0c7f53d7dba_湖北-恩施.jpg', field1: '湖北-恩施' },
{ url: 'http://ncc-yc-cpumall-ec.obs.cn-north-4.myhuaweicloud.com/h050u1t9/cfa7699b-6ae3-4f8b-bcbe-c56bdbdc9bc8_湖北-监利县.jpg', field1: '湖北-监利县' },
{ url: 'http://ncc-yc-cpumall-ec.obs.cn-north-4.myhuaweicloud.com/h050u1t9/53753b9b-0f2b-48e8-b8eb-ce27b18bcb3c_湖北-公安县.jpg', field1: '湖北-公安县' },
{ url: 'http://ncc-yc-cpumall-ec.obs.cn-north-4.myhuaweicloud.com/h050u1t9/0e4bc83a-386d-46e5-809f-da12f392124b_湖北-来凤县.jpg', field1: '湖北-来凤县' }
],
value: '',
name: '',
phone: '',
location: '',
materialDes: '',
msgAlert: '',
userinfo: {},
isOpen: false,
isLoading: false,
loadingText: '提交中',
isToast: false,
toastMsg: '提交成功',
toastType: 'success',
list: [],
list4Supply: [],
list4Donation: [],
pageNum: 0,
pageNum4Supply: 0,
pageNum4Donation: 0,
nameIcon: '',
phoneIcon: '',
locationIcon: '',

realName: '',
realNameIcon: '',
realPhone: '',
realPhoneIcon: '',
identity: ['中间商/代理商'],//身份
material: [
'N95医用防护口罩（GB 19083-2010）及以上',
'医用外科口罩（YY0469-2011)及以上',
'防护服（GB 19082-2003）及以上', '护目镜',
'医用帽', '一次性手术衣',
'医用一次性乳胶手套（GB 10213-2006）',
'防冲击眼罩', '防护面罩', '隔离衣',
'N95口罩', 'KN95口罩', '其他防护物品'
],
materialValue: ['N95医用防护口罩（GB 19083-2010）及以上'],

isAgreeOptions: [{ value: '同意', key: '1' }, { value: '不同意', key: '0' }],
isAgree: ['1'],

spot: [{ value: '是', key: '1' }, { value: '否', key: '0' }],//现货
spotValue: ['1'],

allowCentify: ['1'],
businessAllow: ['1'],
registerCentify: [{ value: '是', key: '1' }, { value: '否', key: '0' }],
registerCentifyValue: ['1'],
productTime: '',
dayNumber: 0,
company: '',
remark: '',
rushHelp: ['捐赠'],
buttonText: '我要捐赠',
buttonTextLeft:'我要采购',
buttonTextRight:'我要供应',
showmodal3:false,
showmodal4:false,
systemId:'',
billId:'',
billOtherId:''
}
},
methods: {
viewpublicdata () {

var redirecturl = encodeURIComponent(location.origin + '/cpu-relief/')
location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa4c7f0efdef96aa7&redirect_uri=${ redirecturl }&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
},
isAuth () {
return this.hasAuth == 0 && (this.visindex == 1 || this.visindex == 3 || this.visindex == 4)
},

help () {
switch(this.visindex){
case 0:
this.showmodalform = true
break;
case 1:
this.showmodalform3 = true
break;
case 2:
this.showmodalform5 = true
break;
}
},

donate () {
switch(this.visindex){
case 0:
this.showmodalform2 = true
break;
case 1:
this.showmodalform4 = true
break;
case 2:
this.showmodalform6 = true
break;
case 3:
this.showmodal3 = true
break;
case 4:
this.showmodal4 = true
break;
}
},
format (ts) {
var d = new Date(ts).Format("yyyy-MM-dd");
return d
},
handler (index) {
this.visindex = index
switch(index){
case 0:

this.getDonationList()
this.buttonTextLeft = "我要募捐"
this.buttonTextRight = "我要捐赠"
break;
case 1:
this.buttonTextLeft = "我要采购"
this.buttonTextRight = "我要供应"
break;
case 2:

this.getSupplyList()
this.buttonTextLeft = "我要捐赠"
this.buttonTextRight = "我要供应"
break;
case 3:
this.buttonTextRight = "我要用车"
break;
case 4:
this.buttonTextRight = "我有资源"
break;
}
},
setIconType (v, icon) {
if (v == "") {
this[icon] = "error"
} else {
this[icon] = "success"
}
},
submit: Debounce(function () {

const _this = this;
if (this.name == "") {
this.nameIcon = "error"
return
}
if (this.location == "") {
this.locationIcon = "error"
return
}
if (this.phone == "") {
this.phoneIcon = "error"
return
}
if (this.materialDes == "") {
this.isToast = true
this.toastMsg = "物资信息必填"
this.toastType = "text"
return
}

axios.post('/yuncai-yop/contribute/save', {
name: this.name,
phone: this.phone,
location: this.location,
materialDes: this.materialDes,
field1:'0'
}).then(function (res) {
_this.isToast = true
_this.toastMsg = "提交成功,物资信息需经平台审核通过后方可公布出来"
_this.toastType = "success"
console.log(res)
}).catch((function (err) {
console.log(err)
_this.isToast = true
_this.toastMsg = "提交失败"
_this.toastType = "warn"
}))
}, 3000),

getDonationList (pageNum4Donation = 0) {
const _this = this;
var data = {
pageNum: pageNum4Donation,
pageSize: 10,
types: [4,5],
systemId: _this.systemId
}
if (this.hasAuth) {
data.auth = 1
}
this.isLoading = true
this.loadingText = "加载中..."
axios.post("/yuncai-yop/contribute/page", data).then(function (res) {
if (res.status == 200) {
let list = res.data.data.list || []
_this.list4Donation = _this.list4Donation.concat(list)
if (res.data.data.nextPage > 0) {
_this.pageNum4Donation = res.data.data.nextPage - 1
} else {
_this.pageNum4Donation = 0
}
}
_this.isLoading = false
}).catch(function (err) {
_this.isLoading = false
console.log(err)
})
},

getPurchaseList (pageNum = 0) {
const _this = this;
var data = {
pageNum: pageNum,
pageSize: 10,
types: [0,10,11],
systemId: _this.systemId
}
if (this.hasAuth) {
data.auth = 1
}
this.isLoading = true
this.loadingText = "加载中..."
axios.post("/yuncai-yop/contribute/page", data).then(function (res) {
if (res.status == 200) {
let list = res.data.data.list || []
_this.list = _this.list.concat(list)
if (res.data.data.nextPage > 0) {
_this.pageNum = res.data.data.nextPage - 1
} else {
_this.pageNum = 0
}
}
_this.isLoading = false
}).catch(function (err) {
_this.isLoading = false
console.log(err)
})
},

getSupplyList (pageNum4Supply = 0) {
const _this = this;
var data = {
pageNum: pageNum4Supply,
pageSize: 10,
types: [1,6,7,8,9],
systemId: _this.systemId
}
if (this.hasAuth) {
data.auth = 1
}
this.isLoading = true
this.loadingText = "加载中..."
axios.post("/yuncai-yop/contribute/page", data).then(function (res) {
if (res.status == 200) {
let list = res.data.data.list || []
_this.list4Supply = _this.list4Supply.concat(list)
if (res.data.data.nextPage > 0) {
_this.pageNum4Supply = res.data.data.nextPage - 1
} else {
_this.pageNum4Supply = 0
}
}
_this.isLoading = false
}).catch(function (err) {
_this.isLoading = false
console.log(err)
})
},
toastHide () {
if (this.toastType !== "text") {
this.name = ''
this.phone = ''
this.location = ''
this.materialDes = ''
}
},
hide () {},

billShowView (item){
this.billId = item.id
switch(item.type){
case 4:
this.showmodalformview = true
break;
case 5:
this.showmodalformview2 = true
break;
case 6:
this.showmodalformview8 = true
break;
case 7:
this.showmodalformview7 = true
break;
case 8:
this.showmodalformview6 = true
break;
case 9:
this.showmodalformview5 = true
break;
case 10:
this.showmodalformview3 = true
break;
case 11:
this.showmodalformview4 = true
break;
}
},
/* ------------------------------ */

myDonation (item){
this.billOtherId = item.id
this.showmodalformother = true
},

mySupply (item){
this.billOtherId = item.id
this.showmodalformother2 = true
},

myPurchase (item){
this.billOtherId = item.id
this.showmodalformother3 = true
},

myFundrais (item){
this.billOtherId = item.id
this.showmodalformother4 = true
},
resetValue () {
this.realName = ''
this.realPhone = ''
},
submitHelp:Debounce(function(){
const _this = this;
if (this.realName == "") {
this.realNameIcon = "error"
window.scroll(0, 0)
return
}
if (this.realPhone == "") {
this.realPhoneIcon = "error"
window.scroll(0, 0)
return
}
axios.post("/yuncai-yop/contributeMaterial/save",
{
name: this.realName,
phone: this.realPhone,
identity: this.identity.join(","),
agentQualify: '',
materials: this.materialValue.join(","),
inStock: this.spotValue.join(","),
mdpl: this.allowCentify.join(","),
businessLicense: this.businessAllow.join(","),
mirc: this.registerCentifyValue.join(","),
packImg: '',
productionDate: this.productTime,
output: this.dayNumber,
company: this.company,
isOpen: this.isAgree.join(","),
rescueType: this.rushHelp.join(","),
remark: this.remark
}).then(function (res) {
console.log(res)
_this.isToast = true
_this.toastMsg = "提交成功"
_this.toastType = "success"
_this.resetValue()
}).catch(function (err) {
console.log(err)
_this.isToast = true
_this.toastMsg = "提交失败"
_this.toastType = "warn"
})
},3000),
getRequest (key) {
var url = location.href.split('?');
var decodeFunc = unescape
if (url.length > 1) {
var theRequest = new Object();
var strs = url[1].split('&');
for (var i = 0; i < strs.length; i++) {
theRequest[strs[i].split('=')[0]] = decodeFunc(strs[i].split('=')[1]);
}
return theRequest[key];
} else {
return null;
}
},
saveViewUser () {
var data = this.userinfo
data.privilege = data.privilege.toString()
axios.post('/yuncai-yop/contribute/saveWXuser', data, { headers: { 'Content-Type': 'application/json' } }).then(res => {
})
}
},
mounted () {
const _this = this

var tag = window.location.search.split('=')[1]
if(tag && tag.includes('hzh')){

this.systemId = 1
document.getElementsByTagName("title")[0].innerText = '互助汇 | 防疫物资紧急采购需求发布平台'
}else{

this.systemId = 0
}
Bus.$on('close-modal',function(v){
switch(_this.visindex){
case 0:
_this.showmodalform = v
_this.showmodalform2 = v
_this.showmodalformview = v
_this.showmodalformview2 = v
_this.showmodalformother = v
case 1:
_this.showmodalform3 = v
_this.showmodalform4 = v
_this.showmodalformview3 = v
_this.showmodalformview4 = v
_this.showmodalformother2 = v
case 2:
_this.showmodalform5 = v
_this.showmodalform6 = v
_this.showmodalformview5 = v
_this.showmodalformview6 = v
_this.showmodalformview7 = v
_this.showmodalformview8 = v

_this.showmodalformother3 = v
_this.showmodalformother4 = v

break;
case 3:
_this.showmodal3 = false
break;
case 4:
_this.showmodal4 = false
break;
}
})

Bus.$on('open-formother',function(v,id){
switch(_this.visindex){
case 0:
_this.showmodalformother = v
_this.billOtherId = id
break;
case 1:
_this.showmodalformother2 = v
_this.billOtherId = id
break;
case 2:
_this.showmodalformother3 = v
_this.showmodalformother4 = v
_this.billOtherId = id
break;
}
})

axios.get('/yuncai-yop/contribute/addVisitRecord', {}, { timeout: 500 })


var ui = localStorage.getItem('ui')
var code = this.getRequest('code')
if (!ui) {

if (code) {
this.hasAuth = 1
axios.get('/yuncai-yop/wechart/userInfo?code=' + code).then(response => {
if (response.data && response.data.status == 1) {
this.userinfo = response.data.data
localStorage.setItem('ui', JSON.stringify(this.userinfo))
this.saveViewUser()
}
})
} else {
this.hasAuth = 0
}
} else {
this.userinfo = JSON.parse(ui)
this.hasAuth = 1
this.saveViewUser()
}


this.getPurchaseList()
axios.post('/yuncai-yop/wechart/sign', {
url: location.href.split('#')[0]
}).then(response => {
if (response.data.status == 1) {
var { signature, appId, nonceStr, timestamp } = response.data.data
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: appId, // 必填，公众号的唯一标识
timestamp: timestamp, // 必填，生成签名的时间戳
nonceStr: nonceStr, // 必填，生成签名的随机串
signature: signature, // 必填，签名
jsApiList: [
'updateAppMessageShareData',
'updateTimelineShareData'
] // 必填，需要使用的JS接口列表
})












}

})

wx.ready(function () {
debugger
var config = {
title: '智慧云采丨防疫物资紧急采购需求发布平台',
desc: '用友采购云-疫区物资公益求助平台,快捷发布信息并通过互联网对接供货渠道',
link: location.href.split('#')[0],
imgUrl: location.origin + '/cpu-relief/static/logo.jpg',
success: function success (res) {
console.log('已分享');
}
}
var tag = window.location.search.split('=')[1]
if(tag && tag.includes('hzh')){
config.title = '互助汇丨防疫物资紧急采购全球供需平台'
config.desc = '互助汇-疫区物资公益求助平台,快捷发布信息并通过互联网对接供货渠道'
config.imgUrl = location.origin + '/cpu-relief/static/logo2.png'
}
wx.updateAppMessageShareData(config);
wx.updateTimelineShareData(config);
})
var abs = 0
var i = 0
setInterval(() => {
if (this.visindex == 0) {
abs -= 26
i++;
if (this.list.length < i + 3) {
abs = 0;
i = 0;
}
this.transform = { transform: 'translateY(' + abs + 'px)' }
}
}, 2000)
}
}



// WEBPACK FOOTER //
// ./src/components/HelloFromVux.vue